<style lang="scss">

</style>

<template>
  <!-- eslint-disable -->
  <div class="post-search-page mb-4">
    <section v-if="showFilters" class="my-2">
      <h4>Filters</h4>

      <div class="row">
        <section class="col-lg-3 col-sm-6">
          <label>Sender name</label>
          <b-form-input
            @keyup.enter="searchPost()" cy="sender"
            @input="updateFilter('senderName', $event)"
            :value="filters.senderName"
            class="mb-1" placeholder="Enter sender name"
          />
        </section>

        <section class="col-lg-3 col-sm-6">
          <label>Before Date</label>
          <b-form-datepicker @input="updateFilter('before', $event, true)" :value="filters.before" locale="en"
                             today-button cy="before"
                             reset-button
                             close-button
                             :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          ></b-form-datepicker>
        </section>

        <section class="col-lg-3 col-sm-6">
          <label>After Date</label>
          <b-form-datepicker @input="updateFilter('after', $event, true)" :value="filters.after" locale="en"
                             today-button cy="after"
                             reset-button
                             close-button
                             :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          ></b-form-datepicker>
        </section>

        <section class="col-lg-3 col-sm-6">
          <label>Sort</label>
          <b-form-select @change="updateFilter('sort', $event, true)" cy="sort"
                         :value="filters.sort" class="mb-1">
            <b-form-select-option value="updated_at">Oldest</b-form-select-option>
            <b-form-select-option value="-updated_at">Newest</b-form-select-option>
          </b-form-select>
        </section>

        <section class="col align-items-center d-flex" style="margin-top: 7px">
          <div class="ui-spacer"></div>
          <b-button class="btn-success ml-1" @click="searchPost()">Search</b-button>
        </section>
      </div>
    </section>

    <b-card no-body class="mb-0">
      <section>
        <b-table
          class="data-table"
          :items="post"
          :fields="headers"
          :current-page="currentPage"
          :per-page="0"
          :responsive="true"
        >
          <template #cell(visitorName)="data">
            {{data.item.visitor.firstname}} {{data.item.visitor.lastname}}
          </template>
          <template #cell(updated_at)="data">
            {{data.item.updated_at | formatDateTime}}
          </template>

          <template #cell(actions)="data">
            <router-link :to="{ name: 'reply-view', params: { id: data.item._id } }" class="font-weight-bold d-block text-nowrap">
              View
            </router-link>
          </template>
        </b-table>
        <b-row class="p-1" v-if="totalRows > filters.limit || totalRows === 0">
          <b-col md="6" class="m-1" v-if="totalRows > filters.limit && showFilters">
            <b-pagination :total-rows="totalRows" :per-page="filters.limit" v-model="currentPage" class="my-0"/>
          </b-col>
          <p v-if="totalRows === 0" class="col-6 ml-2 my-1">No replies to show</p>
        </b-row>
      </section>
    </b-card>
  </div>
  <!-- eslint-enable -->
</template>

<script>
import { mapState } from 'vuex';
import DigitalRepliesService from '@/services/DigitalRepliesService';
import HelperService from '../../services/HelperService';

export default {
  name: 'DigitalRepliesSearch',
  components: {},
  props: {
    showFilters: {
      required: false,
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      helperService: new HelperService(),
      loading: true,
      headers: [
        { label: 'From', key: 'sender_name' },
        { label: 'Date', key: 'updated_at' },
        { label: '', key: 'actions' },
      ],
      post: [],
      currentPage: 1,
      totalRows: 10,
    };
  },
  computed: {
    ...mapState({
      filters: state => state.replies.filters,
    }),
  },
  watch: {
    currentPage() {
      this.getPost();
    },
  },
  mounted() {
    this.getPost();
  },
  methods: {
    searchPost() {
      this.currentPage = 1;
      this.getPost();
    },
    getPost() {
      this.updateFilter('skip', (this.currentPage - 1) * this.filters.limit);

      DigitalRepliesService.getAll(this.filters).then(res => {
        this.loading = false;
        this.post = res.data.data;
        this.totalRows = res.data.count;
      }).catch(err => {
        console.log('Error getting post ', err);
        this.$toast.error('Could not get post, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    updateFilter(filterName, e, refresh) {
      this.$store.commit('replies/SET_FILTER_ITEM', { name: filterName, value: e });

      if (refresh) {
        this.searchPost();
      }
    },
  },
};
</script>
